import {required, email, minLength, maxLength} from 'vuelidate/lib/validators'

const validUrl = (reqProtocols) => (val) =>{
    const regexQuery = `^(https?://)${reqProtocols ? '' : '?'}(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$`
    const url = new RegExp(regexQuery, "i")
    return url.test(val)
}

const validMail = (val) =>{
    const regexQuery = "^\\w+([\\+.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$"
    const email = new RegExp(regexQuery, "i")
    return email.test(val)
}


export default {
    props: [
      "name", "type", "placeholder", "min", "invalide", "pasted", "dis",
        'value', 'isReq', 'isTouch', 'message', 'required', "max",
        "customMessage", 'noEmit', 'checkOnMount', 'reqProtocols'],
    data() {
        return {
            update: true,
            autocomplete: false,
            inp: '',
            inval: false,
            minLength: this.$props.min ?? 0,
            maxLength: this.$props.max ?? 255,
            req: this.$props.isReq ?? false,
            touche: this.$props.isTouch ?? false,
            mes: ''
        }
    },
    methods: {
        emited(isTouch = false) {
            this.$emit('input', {inp: this.inp, invalide: this.$v.$error, error: this.$v.$error, fromTouch: isTouch})
        },
        touch(flag = true) {
            if (this.required) {
                this.$v.inp.$touch()
            }
            if (flag)
                this.emited(true)
        },
        rerender() {
            this.update = false
            this.update = true
        },
        updateInput(data) {
            this.inp = data
            this.touch(false)
            this.emited()
        },
        saveTouch() {
            this.touche = this.$props.isTouch
            this.$v.inp.$touch()
            this.emited()

        },
        savePasted() {
            this.inp = this.$props.pasted
            this.emited(true)

        },
        saveMessage() {
            this.mes = this.$props.message
            this.emited()

        },
        saveInvalide() {
            this.inval = this.$props.invalide
            if (this.$props.noEmit) return
            this.emited()
        }
    },
    validations() {
        if (this.$props.type === 'url') {
            return {
                inp: {
                    required,
                    validUrl: validUrl(this.$props.reqProtocols)
                }
            }
        }
        if (this.$props.type === 'email') {
            this.autocomplete = true
            return {
                inp: {
                    required, validMail
                }
            }
        }
        if (this.$props.type === 'name') {
            return {
                inp:
                required
            }
        }
        if (this.$props.type === 'tel') {
            this.autocomplete = true
            return {
                inp:
                required
            }
        }
        if (this.$props.type === 'text') {
            return {
                inp: {
                    required,
                    minLength: minLength(this.minLength)
                }
            }
        }
        if (this.$props.type === 'text') {
            return {
                inp: {
                    required,
                    maxLength: maxLength(this.maxLength)
                }
            }
        }
        if (this.$props.type === 'password') {
            this.autocomplete = true
            return {
                inp: {
                    required,
                    minLength: minLength(this.minLength)
                }
            }
        }
        if (this.$props.type === 'confirm-password') {
            return {
                inp: {
                    required,
                    minLength: minLength(this.minLength)
                }
            }
        }
    },
    mounted() {
        if (this.$props.checkOnMount) {
            this.saveInvalide()
        }
        if (this.$props.pasted) {
            this.inp = this.$props.pasted
        }
    },
    watch: {
        pasted: 'savePasted',
        message: 'saveMessage',
        isTouch: 'saveTouch',
        invalide: 'saveInvalide'
    }
}
